import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import './AdminDashboard.css';

const Sidebar = ({ activeTab, setActiveTab, onLogout }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuGroups = [
    {
      title: 'MAIN OPERATIONS',
      items: [
        { id: 'live', icon: 'ion:pulse-outline', label: 'Live Operations' },
        { id: 'analytics', icon: 'ion:stats-chart-outline', label: 'Analytics' },
        { id: 'candidates', icon: 'ion:people-outline', label: 'Candidates' },
      ]
    },
    {
      title: 'MANAGEMENT',
      items: [
        { id: 'setup', icon: 'ion:construct-outline', label: 'Setup Wizard' },
        { id: 'users', icon: 'ion:people-outline', label: 'Staff' },
        { id: 'devices', icon: 'ion:hardware-chip-outline', label: 'Hardware Grid' },
      ]
    },
    {
      title: 'USER SETTINGS',
      items: [
        { id: 'profile', icon: 'ion:person-circle-outline', label: 'My Profile' },
      ]
    }
  ];

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-toggle" onClick={() => setIsCollapsed(!isCollapsed)}>
        <Icon icon={isCollapsed ? "ion:chevron-forward" : "ion:chevron-back"} />
      </div>

      <div style={{
        padding: isCollapsed ? '24px 0' : '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: isCollapsed ? '0' : '12px',
        borderBottom: '1px solid var(--border-light)',
        minHeight: '89px',
        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
      }}>
        <div style={{
          width: '42px',
          height: '42px',
          background: 'var(--primary)',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          minWidth: '42px',
          boxShadow: '0 4px 12px rgba(128, 0, 0, 0.2)',
          margin: isCollapsed ? '0 auto' : '0'
        }}>
          <Icon icon="ion:shield-checkmark" width="22" height="22" />
        </div>
        {!isCollapsed && <span style={{ fontWeight: 800, fontSize: '18px', color: 'var(--primary)', letterSpacing: '-0.5px' }}>ICFF INDIA</span>}
      </div>

      <nav 
        className="hide-scrollbar"
        style={{ 
          padding: '20px 0', 
          display: 'flex', 
          flexDirection: 'column', 
          width: '100%', 
          gap: '6px',
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        {menuGroups.map((group, groupIdx) => (
          <React.Fragment key={groupIdx}>
            {!isCollapsed && (
              <div className="sidebar-heading">
                {group.title}
              </div>
            )}
            {group.items.map((item) => {
              const isActive = activeTab === item.id;
              return (
                <button
                  key={item.id}
                  className={`nav-item ${isActive ? 'active' : ''}`}
                  onClick={() => setActiveTab(item.id)}
                  style={{
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: isCollapsed ? 'center' : 'flex-start',
                    padding: isCollapsed ? '14px 0' : '14px 24px',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    color: isActive ? 'var(--primary)' : 'var(--sidebar-text)',
                  }}
                >
                  {/* Animated Background Pill */}
                  {isActive && (
                    <motion.div
                      layoutId="activeTabPill"
                      className="nav-active-pill"
                      transition={{ type: 'spring', stiffness: 350, damping: 30 }}
                    />
                  )}

                  {/* Animated Left Indicator */}
                  {isActive && (
                    <motion.div
                      layoutId="activeTabIndicator"
                      className="nav-active-indicator"
                      transition={{ type: 'spring', stiffness: 350, damping: 30 }}
                    />
                  )}

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    position: 'relative',
                    zIndex: 2,
                    transform: isActive && !isCollapsed ? 'translateX(6px)' : 'none',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
                  }}>
                    <Icon
                      icon={item.icon}
                      width="24"
                      height="24"
                      style={{
                        color: isActive ? 'var(--primary)' : 'var(--sidebar-text)',
                        filter: isActive
                          ? 'drop-shadow(0 0 8px rgba(128, 0, 0, 0.3))'
                          : 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05))',
                        transition: 'all 0.3s ease',
                        opacity: isActive ? 1 : 0.85
                      }}
                    />
                    {!isCollapsed && (
                      <span className="nav-label" style={{
                        fontSize: '15px',
                        fontWeight: isActive ? 700 : 500,
                        letterSpacing: '0.1px',
                        opacity: isActive ? 1 : 0.9
                      }}>
                        {item.label}
                      </span>
                    )}
                  </div>
                </button>
              );
            })}
          </React.Fragment>
        ))}
      </nav>

      <div style={{ marginTop: 'auto', padding: '20px', borderTop: '1px solid var(--border-light)', display: 'flex', justifyContent: 'center' }}>
        <button
          className="universal-logout-btn"
          onClick={onLogout}
        >
          <Icon icon="ion:log-out-outline" width="22" height="22" />
          {!isCollapsed && <span className="nav-label" style={{ fontWeight: 700 }}>Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
